module.exports = __webpack_public_path__ + "img/open-msg.1d5a2fa7.png";